import React from 'react';

const TagsOverlay = (props) => (
      <div className={`StickerContainer ${props.visibleClass}`}>
        <span>choose up to three</span><div className="tagOverLayClose" onClick={props.toggleTagsOverLay} > x </div>
        <div className="StickerContent">
        { props.children }
        </div>
      </div>
)

export default TagsOverlay




// WEBPACK FOOTER //
// ./src/templates/TagsOverlay.js